import React from 'react';

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
}

export default function useFomo({ searchId, profileId, isFeatured }) {
  const [watchersCount, setWatchersCount] = React.useState<number>(0);

  React.useEffect(() => {
    if (searchId && profileId) {
      let cachedData = localStorage.getItem('profileWatchers');
      if (cachedData) {
        cachedData = JSON.parse(cachedData);
        const watchers: any = cachedData?.[searchId]?.[profileId] || 0;
        if (watchers) {
          setWatchersCount(watchers);
        } else {
          generateWatchers(cachedData);
        }
      } else {
        generateWatchers();
      }
    }
  }, [searchId, profileId]);

  function generateWatchers(existingData?) {
    const count =
      (isFeatured && getRandomIntInclusive(2, 10)) ||
      getRandomIntInclusive(0, 4);
    let cacheObj: any = {};
    if (!existingData) {
      cacheObj = {
        [searchId]: {
          [profileId]: count,
        },
      };
    } else {
      const currentData = existingData[searchId] || {};
      cacheObj = {
        [searchId]: { ...currentData, [profileId]: count },
      };
    }
    setWatchersCount(count);
    localStorage.setItem('profileWatchers', JSON.stringify(cacheObj));
  }

  return { watchersCount };
}
